const Place_exchange_Bet_amounts = Object.freeze([
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '500', value: 500 },
    { label: '1000', value: 1000 },
    { label: '2000', value: 2000 },
    { label: '5000', value: 5000 },
]);

export default Place_exchange_Bet_amounts;